var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-row",
    { staticClass: "foreground", attrs: { dense: _vm.dense } },
    [
      _c(
        "v-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            {
              attrs: {
                color: "grey darken-3",
                "data-cy": "controlRow",
                elevation: "3",
              },
            },
            [
              _vm.$vuetify.breakpoint.xsOnly
                ? _c("ResponsiveRowSmall", {
                    on: {
                      toggle: function ($event) {
                        return _vm.$emit("toggle")
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "status",
                          fn: function () {
                            return [_vm._t("status")]
                          },
                          proxy: true,
                        },
                        {
                          key: "set",
                          fn: function () {
                            return [_vm._t("set")]
                          },
                          proxy: true,
                        },
                        {
                          key: "severity",
                          fn: function () {
                            return [_vm._t("severity")]
                          },
                          proxy: true,
                        },
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._t("title")]
                          },
                          proxy: true,
                        },
                        {
                          key: "id",
                          fn: function () {
                            return [_vm._t("id")]
                          },
                          proxy: true,
                        },
                        {
                          key: "tags",
                          fn: function () {
                            return [_vm._t("tags")]
                          },
                          proxy: true,
                        },
                        {
                          key: "runTime",
                          fn: function () {
                            return [_vm._t("runTime")]
                          },
                          proxy: true,
                        },
                        {
                          key: "viewed",
                          fn: function () {
                            return [_vm._t("viewed")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm.$vuetify.breakpoint.mdAndDown
                ? _c("ResponsiveRowMedium", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "status",
                          fn: function () {
                            return [_vm._t("status")]
                          },
                          proxy: true,
                        },
                        {
                          key: "set",
                          fn: function () {
                            return [_vm._t("set")]
                          },
                          proxy: true,
                        },
                        {
                          key: "severity",
                          fn: function () {
                            return [_vm._t("severity")]
                          },
                          proxy: true,
                        },
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._t("title")]
                          },
                          proxy: true,
                        },
                        {
                          key: "id",
                          fn: function () {
                            return [_vm._t("id")]
                          },
                          proxy: true,
                        },
                        {
                          key: "tags",
                          fn: function () {
                            return [_vm._t("tags")]
                          },
                          proxy: true,
                        },
                        {
                          key: "runTime",
                          fn: function () {
                            return [_vm._t("runTime")]
                          },
                          proxy: true,
                        },
                        {
                          key: "viewed",
                          fn: function () {
                            return [_vm._t("viewed")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _c("ResponsiveRowLarge", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "status",
                          fn: function () {
                            return [_vm._t("status")]
                          },
                          proxy: true,
                        },
                        {
                          key: "set",
                          fn: function () {
                            return [_vm._t("set")]
                          },
                          proxy: true,
                        },
                        {
                          key: "severity",
                          fn: function () {
                            return [_vm._t("severity")]
                          },
                          proxy: true,
                        },
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._t("title")]
                          },
                          proxy: true,
                        },
                        {
                          key: "id",
                          fn: function () {
                            return [_vm._t("id")]
                          },
                          proxy: true,
                        },
                        {
                          key: "tags",
                          fn: function () {
                            return [_vm._t("tags")]
                          },
                          proxy: true,
                        },
                        {
                          key: "runTime",
                          fn: function () {
                            return [_vm._t("runTime")]
                          },
                          proxy: true,
                        },
                        {
                          key: "viewed",
                          fn: function () {
                            return [_vm._t("viewed")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }